import { render, staticRenderFns } from "./UnitsView.vue?vue&type=template&id=68d79026"
import script from "./UnitsView.vue?vue&type=script&lang=js"
export * from "./UnitsView.vue?vue&type=script&lang=js"
import style0 from "./UnitsView.vue?vue&type=style&index=0&id=68d79026&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports